module.exports = __webpack_public_path__ + "assets/events_disasters_white.d91c733f.svg";